export class DeleteVolumeByIntervalUseCase {
  constructor(repository) {
    this.repository=repository
  }
  async execute(FK_SECTOR,START,END=null) {
    if(START && END){
      return await this.repository.deleteByInterval(FK_SECTOR,START,END)
    }
    return await this.repository.deleteByTime(FK_SECTOR,START)
  }
}
